import React, { useEffect } from "react";
import {
  ErrorModalIcon,
  InfoModalIcon,
  SuccessCheckIcon,
  WarningModalIcon,
} from "../../assets";
import { useMessage } from "../../context/MessageContext";

const MessageModal: React.FC = () => {
  const { message, type, detail, setMessage } = useMessage();

  useEffect(() => {
    if (message) {
      // A message with a detail sentence stays up longer, so it can be read
      const timer = setTimeout(() => {
        setMessage("", "success");
      }, detail ? 6000 : 3000);

      return () => clearTimeout(timer);
    }
  }, [message, detail, setMessage]);

  if (!message) return null;

  const getIcon = () => {
    switch (type) {
      case "success":
        return <SuccessCheckIcon />;
      case "info":
        return <InfoModalIcon />;
      case "warning":
        return <WarningModalIcon />;
      case "error":
        return <ErrorModalIcon />;
      default:
        return <SuccessCheckIcon />;
    }
  };

  return (
    <div className="modal modalSuccessfull modal--open">
      <div className="modal__dialog">
        <div className="modal__content">
          <div className="modal__header">
            <div className="modal__header--logo">{getIcon()}</div>
          </div>
          <div className="modal__body">
            <h4 className="promptMessage">{message}</h4>
            {detail && <p className="promptMessage__detail">{detail}</p>}
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};

export default MessageModal;
